import { Icon, Link } from '../../../components';
import { useHasExternals } from '../../../shared';
import { getExternalConversationUrl } from '../../../utilities';

type ExternalConversationLinkProps = {
  asBlock?: boolean;
  children?: React.ReactNode;
  contactPhone?: string | null;
};

const ExternalConversationLink: React.FC<ExternalConversationLinkProps> = ({
  children,
  contactPhone,
  asBlock = true,
}) => {
  const hasExternals = useHasExternals();
  if (!hasExternals || !contactPhone) return children;

  const url = getExternalConversationUrl({ contactPhone });
  if (!url) return children;

  return (
    <Link
      external
      url={url}
      className={asBlock ? 'flex flex-row items-center' : ''}
    >
      {children}
      <Icon
        icon="link"
        className="ml-sm"
        tooltip="View Conversations in Admin"
      />
    </Link>
  );
};

export default ExternalConversationLink;
